"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../../util");
var MotorSpec = (function () {
    function MotorSpec() {
    }
    MotorSpec.prototype.move = function (left, right, durationMs) {
        if (durationMs === void 0) { durationMs = 0; }
        var lSign = left > 0 ? 1 : -1;
        var rSign = right > 0 ? 1 : -1;
        var lDirection = left > 0 ? 1 : 2;
        var rDirection = right > 0 ? 1 : 2;
        var lPower = Math.min(Math.abs(left), 100);
        var rPower = Math.min(Math.abs(right), 100);
        var duration = util_1.clamp(durationMs / 10, 0, 255);
        return {
            buffer: Buffer.from([2, 1, lDirection, lPower, 2, rDirection, rPower, duration]),
            data: {
                left: lSign * lPower,
                right: rSign * rPower,
                durationMs: duration * 10,
            },
        };
    };
    return MotorSpec;
}());
exports.MotorSpec = MotorSpec;
//# sourceMappingURL=motor-spec.js.map